<template>
  <v-row justify="center" class="my-2">
    <div class="text-center">
      <div class="caption grey--text mb-1">2D kod za plaćanje (HUB3A)</div>
      <img v-if="slika" :src="slika" alt="2D kod za plaćanje" class="kod" />
      <div v-else class="caption red--text">{{ greska || 'Kod nije moguće složiti.' }}</div>
    </div>
  </v-row>
</template>

<script>
import generateBarcode from 'pdf417'
import { hub3Tekst, ascii } from '@/snippets/hub3'

// Sadrzaj koda slaze snippets/hub3.js - isti pomocnik koristi i ispis racuna,
// da se dvije kopije ne raziđu. Ovdje je platitelj nasa firma (Platitelj1-3),
// primatelj dobavljac; prijasnja inacica imala ih je zamijenjene.

export default {
  name: 'BankPaymentCode',
  props: ['vir'],
  data: () => ({
    slika: null,
    sadrzaj: '',
    greska: null
  }),
  created () {
    this.slozi()
  },
  watch: {
    // Dijalog se otvara za razlicite virmane bez ponovnog stvaranja
    // komponente, pa bi se inace prikazivao kod prvog otvorenog naloga.
    vir: {
      deep: true,
      handler () { this.slozi() }
    }
  },
  methods: {
    slozi () {
      this.greska = null
      this.slika = null
      const v = this.vir || {}
      try {
        const iban = ascii(v.PrimateljIBAN).replace(/\s/g, '')
        if (!iban) {
          this.greska = 'Nema IBAN-a primatelja, kod se ne može složiti.'
          return
        }
        this.sadrzaj = hub3Tekst({
          iznos: v.Iznos,
          platiteljIme: v.Platitelj1,
          platiteljAdresa: v.Platitelj2,
          platiteljMjesto: v.Platitelj3,
          primateljIme: v.Primatelj1,
          primateljAdresa: v.Primatelj2,
          primateljMjesto: v.Primatelj3,
          iban: iban,
          model: v.PrimateljModel,
          poziv: v.PrimateljPoziv,
          namjena: 'COST',
          opis: [ascii(v.Opis1), ascii(v.Opis2)].filter(x => x).join(' ')
        })
        this.slika = generateBarcode(this.sadrzaj, 4, 2)
      } catch (err) {
        // eslint-disable-next-line
        console.log('2D kod:', err)
        this.greska = 'Kod nije moguće složiti.'
      }
    }
  }
}
</script>

<style scoped>
/* Bez razvlacenja - PDF417 se cita samo dok su omjeri crtica netaknuti. */
.kod {
  display: block;
  max-width: 100%;
  height: auto;
  background: #fff;
  padding: 6px;
}
</style>
